import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { PremierConstants } from 'premier-constant-service';
import presentationPLMetadata  from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import presentationCTMetadata  from "gw-capability-gateway-quoteandbind-PremierCT-react/config/PremierCT-wizard-config.json5";
import presentationSWMetadata  from "gw-capability-gateway-quoteandbind-PremierSW-react/config/PremierSW-wizard-config.json5";
import presentationCLMetadata  from "gw-capability-gateway-quoteandbind-PremierCL-react/config/PremierCL-wizard-config.json5";
import presentationSCMetadata  from "gw-capability-gateway-quoteandbind-PremierSC-react/config/PremierSC-wizard-config.json5";
import presentationPRMetadata  from "gw-capability-gateway-quoteandbind-PremierPR-react/config/PremierPR-wizard-config.json5";
import presentationRVMetadata  from "gw-capability-gateway-quoteandbind-PremierRV-react/config/PremierRV-wizard-config.json5";
import presentationELMetadata  from "gw-capability-gateway-quoteandbind-PremierEL-react/config/PremierEL-wizard-config.json5";
import presentationLEMetadata  from "gw-capability-gateway-quoteandbind-PremierLE-react/config/PremierLE-wizard-config.json5";
import presentationSRMetadata  from "gw-capability-gateway-quoteandbind-PremierSR-react/config/PremierSR-wizard-config.json5";
import presentationRMMetadata  from "gw-capability-gateway-quoteandbind-PremierRM-react/config/PremierRM-wizard-config.json5";
import appConfig from 'app-config';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ServiceManager } from '@jutro/legacy/services';
import metadata from './OfferingsPage.metadata.json5';
import './Offerings.messages';

function OfferingsPage(props) {
    const { authHeader } = useAuthentication();
    const {
        wizardData, updateWizardData, changeNextSteps
    } = props;
    const { showConfirm } = useModal();
    const selectedLanguage = ServiceManager.getService('locale-service').getStoredLanguage()
    const getSteps = () => {

         if (wizardData.value.baseData.productCode === "ProLinProduct") {
            return _.get(presentationPLMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        } 
        
        if (wizardData.value.baseData.productCode === "SpaAndWelProduct") {
            return _.get(presentationSWMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        } 
        
        if (wizardData.value.baseData.productCode === "CybLiaProduct") {
            return _.get(presentationCLMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }
        
        if (wizardData.value.baseData.productCode === "ConsTraAndServProduct") {
            return _.get(presentationCTMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        } 
        
        if (wizardData.value.baseData.productCode === "SpeLinProduct") {
           return _.get(presentationSCMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }

        if (wizardData.value.baseData.productCode === "RecVehProduct") {
            return _.get(presentationRVMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        } 
        
        if (wizardData.value.baseData.productCode === "PerProduct") {
           return _.get(presentationPRMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }

        if (wizardData.value.baseData.productCode === "SpoAndRecProduct") {
           return _.get(presentationSRMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }

        if (wizardData.value.baseData.productCode === "EnvProduct") {
           return _.get(presentationELMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }

        if (wizardData.value.baseData.productCode === "RecMarProduct") {
           return _.get(presentationRMMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }

        if (wizardData.value.baseData.productCode === "EveLiaProduct") {
           return _.get(presentationLEMetadata, [`${wizardData.value.baseData.productCode}.default.wizard`, 'steps']);
        }
        
        return []
    };
    const steps = getSteps()
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');

    const { isComponentValid } = useValidation('OfferingsPage');
    const filteredSteps = _.filter(steps, (wizardStep) => !(wizardStep.id.includes('property') || wizardStep.id.includes('propertyCoverages')))
	
	const { lineName } = PremierConstants;
    const productCode = _.get(wizardData.value, 'baseData.productCode');
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : '';
    const [initOffering] = useState(_.get(wizardData.value, `lobData.${lobLineName}.selectedOffering_Ext`));
    const onNext = useCallback(async () => {
        
        const selectedOffValue = _.get(wizardData.value, `lobData.${lobLineName}.selectedOffering_Ext`);

        if(!_.isUndefined(initOffering) && initOffering !== selectedOffValue) {
            const results = await showConfirm({
                title: 'Data Loss Warning',
                message: 'Please be aware that changing the offering will result in complete data loss for the previously selected offering. Are you sure you want to proceed?',
                status: 'warning',
                icon: 'mi-warning-outline',
                confirmButtonText: commonMessages.yes,
                cancelButtonText: 'No'
            })

            if (results === 'cancel' || results === 'close') {
                return false
            }

            const jobNumber =  wizardData.value.quoteID || wizardData.value.jobID
            const {jobType} = wizardData.value.baseData;
            const jobService = jobType === 'PolicyChange' ? EndorsementService : LoadSaveService;

            wizardData.value = await jobService
            .updateOfferings_Ext(jobNumber, selectedOffValue,  authHeader);

            const selectOffering = _.get(wizardData.value, `lobData.${lobLineName}.selectedOffering_Ext`)

            changeNextSteps(_.filter(filteredSteps, (step) => !step.id.includes('off') || step.id.includes(selectOffering)).splice(1, filteredSteps.length))
    
            return wizardData;
        } 
        
        if(_.isUndefined(initOffering) && initOffering !== selectedOffValue) {

            const jobNumber =  wizardData.value.quoteID || wizardData.value.jobID
            const {jobType} = wizardData.value.baseData;
            const jobService = jobType === 'PolicyChange' ? EndorsementService : LoadSaveService;

            wizardData.value = await jobService
            .updateOfferings_Ext(jobNumber, selectedOffValue,  authHeader);

            const selectOffering = _.get(wizardData.value, `lobData.${lobLineName}.selectedOffering_Ext`)

            changeNextSteps(_.filter(filteredSteps, (step) => !step.id.includes('off') || step.id.includes(selectOffering)).splice(1, filteredSteps.length))
    
            return wizardData;
        }
 
        return wizardData;
    },[wizardData, lobLineName, initOffering, showConfirm, EndorsementService, LoadSaveService, authHeader, changeNextSteps, filteredSteps]
    );

    const filteredOfferings = useCallback((filteredList) =>{
        let filteredDropdownValues = [];

        filteredDropdownValues = filteredList ? filteredList.map((item) => ({
                code: item.branchCode,
                name: item.branchName,
            }))
            : [];

        return filteredDropdownValues;
    },[]);

    const buildAvailableValuesForDropdown = () => {
        const offeringList = _.get(wizardData.value, `lobData.${lobLineName}.offerings_Ext`);
        let offeringDropDown = []

         if (wizardData.value.baseData.productCode === "EnvProduct") {
          const filteredList = _.filter(offeringList, (offering) =>
            appConfig.pelAllowedOffering.includes(offering.branchCode)
          );

          offeringDropDown = filteredOfferings(filteredList)

        } else if (wizardData.value.baseData.productCode === "ProLinProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.pplAllowedOffering.includes(offering.branchCode)
            );

            offeringDropDown = filteredOfferings(filteredList)
        } else if (wizardData.value.baseData.productCode === "SpoAndRecProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.psrAllowedOffering.includes(offering.branchCode)
            );

            offeringDropDown = filteredOfferings(filteredList)
        } 
        else if (wizardData.value.baseData.productCode === "CybLiaProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.pclAllowedOffering.includes(offering.branchCode)
            );

            offeringDropDown = filteredOfferings(filteredList)
        } 
        else if (wizardData.value.baseData.productCode === "SpaAndWelProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
               appConfig.pswAllowedOffering.includes(offering.branchCode)
            );

             offeringDropDown = filteredOfferings(filteredList)
         } 
        else if (wizardData.value.baseData.productCode === "ConsTraAndServProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.pctAllowedOffering.includes(offering.branchCode)
        );        

            offeringDropDown = filteredOfferings(filteredList);
        } else if (wizardData.value.baseData.productCode === "SpeLinProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.pscAllowedOffering.includes(offering.branchCode)
        );        

            offeringDropDown = filteredOfferings(filteredList);
        } else if (wizardData.value.baseData.productCode === "RecVehProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.prvAllowedOffering.includes(offering.branchCode)
        );        

            offeringDropDown = filteredOfferings(filteredList);
        } else if (wizardData.value.baseData.productCode === "PerProduct") {
            const filteredList = _.filter(offeringList, (offering) =>
                appConfig.pprAllowedOffering.includes(offering.branchCode)
        );        

            offeringDropDown = filteredOfferings(filteredList);
        } else {
            offeringDropDown = filteredOfferings(offeringList);
        }

        if (!_.isUndefined(selectedLanguage) && selectedLanguage === 'fr-CA' && offeringDropDown.length > 0) {
            offeringDropDown = _.filter(offeringDropDown, (offering) => !appConfig.unsupportedOfferingForFR.includes(offering.code));
        }
        
        return offeringDropDown
    };

    const writeValue = useCallback((value, path) => {
        _.set(wizardData, path, value);
        updateWizardData(wizardData);
    }, [wizardData, updateWizardData]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showRequired: true,
        },
        offeringsDropdown: {
            availableValues: buildAvailableValuesForDropdown(),
            onValueChange: writeValue,
            path: `lobData.${lobLineName}.selectedOffering_Ext`
        }
    };

    return (
        <WizardPage
            disableNext={!isComponentValid}
            onNext={onNext}
            onSave={onNext}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
            />
        </WizardPage>
    );
}

OfferingsPage.propTypes = wizardProps;
export default withViewModelService(OfferingsPage);